import { render, staticRenderFns } from "./file.vue?vue&type=template&id=a98087b6&"
import script from "../descriptors/file.js?vue&type=script&lang=js&"
export * from "../descriptors/file.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports